export default class slider {
    constructor(manager,top) {

        //manager
        this.manager = manager;
        this.topManager = top;

    }
    init(){

        this.zoom();

        //pager
        for(let i in this.topManager.$slidePager) {
            if (this.topManager.$slidePager[i].nodeType != 1) continue;
            this.topManager.$slidePager[i].addEventListener("click", () => {

                if(this.topManager.status.motion || this.topManager.status.current == i) return;

                this.topManager.status.motion = true;
                this.topManager.status.next = i;

                this.pagerUpdate();
                this.out();
                this.in();

            });
        }

    }
    out(){
        TweenMax.to(this.topManager.$slideList[this.topManager.status.current],2.9,{
            display:'none',
            opacity:0,
            ease:this.manager.ease
        });
    }
    in(){

        this.manager.color.set(
            this.topManager.colorArray.logoColor[this.topManager.status.next],
            this.topManager.colorArray.snsColor[this.topManager.status.next],
            this.topManager.colorArray.footerColor[this.topManager.status.next],
            this.topManager.colorArray.menuColor[this.topManager.status.next],
            this.topManager.colorArray.headerOpacity[this.topManager.status.next]
        );

        this.topManager.status.current = this.topManager.status.next;
        this.zoom();
        TweenMax.to(this.topManager.$slideList[this.topManager.status.next],2.9,{
            display:'block',
            opacity:1,
            ease:this.manager.ease,
            onStart: () => {
                setTimeout(()=>{
                    this.topManager.status.motion = false;
                },10e2);
            }
        });
    }
    zoom(){
        if(this.manager.status.loaded){
            TweenMax.fromTo(this.topManager.$slideList[this.topManager.status.current].querySelector('.image'),7,{
                rotation:-1,
                scale: 1.08,
            },{
                rotation:0,
                scale: 1,
                ease:Power0.easeNone
            });
        }else{ //初回読み込みの時だけはこちら
            TweenMax.fromTo(this.topManager.$slideList[this.topManager.status.current].querySelector('.image'),3.8,{
                rotation:1,
                scale: 1.34,
            },{
                delay:0.1,
                rotation:0,
                scale: 1,
                ease:Expo.easeOut
            });
        }
    }
    pagerUpdate(){
        for(let i in this.topManager.$slidePager) {
            if (this.topManager.$slidePager[i].nodeType != 1) continue;

            if(this.topManager.status.next == i){
                this.topManager.$slidePager[i].classList.add('is-current');
            }else{
                this.topManager.$slidePager[i].classList.remove('is-current');
            }

        }
    }
    render(){

        if(this.topManager.status.motion) return;

        this.topManager.status.slideTime = Number(this.topManager.status.slideTime) + 1;
        if(this.topManager.status.slideTime == 330){
            if(this.topManager.status.current == this.topManager.status.max){
                this.topManager.status.next = 0;
            }else{
                this.topManager.status.next = Number(this.topManager.status.current) + 1;
            }

            this.topManager.status.motion = true;
            this.pagerUpdate();
            this.out();
            this.in();
            this.topManager.status.slideTime = 0;
        }
    }
    resize(){

    }
}